<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <!--<b-tab :title="$t('config.reEvaluate.byProvinces')" active>-->
                                <!--<ReEvaluateProvince/>-->
                            <!--</b-tab>-->
                            <!-- <b-tab title="2018">
                                <IndexYear2017 :date="'01/01/2018'"></IndexYear2017>
                            </b-tab>
                            <b-tab title="2019">
                                <IndexYear2017 :date="'01/01/2019'"></IndexYear2017>
                            </b-tab>
                            <b-tab title="2020">
                                <IndexYear2017 :date="'01/01/2020'"></IndexYear2017>
                            </b-tab>
                            <b-tab title="2021">
                                <IndexYear2017 :date="'01/01/2021'"></IndexYear2017>
                            </b-tab> -->
                            <div v-for="(year,index) in years" :key="index">
                                <b-tab :title="`${year}`">
                                    <IndexYear2017 :date="'01/01/'+`${year}`"></IndexYear2017>
                                </b-tab>
                            </div>
                            <!--<b-tab :title="$t('config.reEvaluate.constructions')">-->
                                <!--<ConstructionsView></ConstructionsView>-->
                            <!--</b-tab>-->
                            <!--<b-tab :title="$t('config.reEvaluate.transfer_devices')">-->
                                <!--<TransferDevicesView></TransferDevicesView>-->
                            <!--</b-tab>-->
                            <!--<b-tab :title="$t('config.reEvaluate.machinery_and_equipment')">-->
                                <!--<MachineryAndEquipment></MachineryAndEquipment>-->
                            <!--</b-tab>-->
                            <!--<b-tab :title="$t('config.reEvaluate.vehicles')">-->
                                <!--<ReEvaluateVehicles></ReEvaluateVehicles>-->
                            <!--</b-tab>-->
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    // import ReEvaluateProvince from '@/views/config/re-evaluate/ReEvaluateProvince';
    import IndexYear2017 from '@/views/config/re-evaluate/IndexYear2017';
    // import ConstructionsView from '@/views/config/re-evaluate/ConstructionsView';
    // import TransferDevicesView from '@/views/config/re-evaluate/TransferDevicesView';
    // import MachineryAndEquipment from '@/views/config/re-evaluate/MachineryAndEquipment';
    // import ReEvaluateVehicles from '@/views/config/re-evaluate/ReEvaluateVehicles';

    export default {
        name: "ReEvaluateConfig",
        components: {
            'b-tabs': bTabs,
            'b-tab': bTab,
            // ReEvaluateProvince,
            IndexYear2017,
            // ConstructionsView,
            // TransferDevicesView,
            // MachineryAndEquipment,
            // ReEvaluateVehicles
        },
        data() {
            return {
                years: []
            }
        },
        methods: {
            init() {
                let minYear = 2018;
                while (minYear <= new Date().getFullYear()) {
                    this.years.push(minYear);
                    minYear++;
                }
            }
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>

</style>